module.exports = __webpack_public_path__ + "static/media/Plane.581451ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapDecoration/Plane.png
// module id = 857
// module chunks = 0